module.exports = __webpack_public_path__ + "img/googleplay_2208x1242_04_EgyptHldRspn_5R.bf4f3a94.png";